import { RemoveYear, hasInErrorReason } from "../utils/helpers";

class DisabilitySnapshotsData {
    format = (response) => {
        const searchResultMetadata = {
            startIndex: response.searchResultMetadata.startIndex,
            totalResults: response.searchResultMetadata.totalResults,
            itemsPerPage: response.searchResultMetadata.itemsPerPage,
            timeTaken: response.searchResultMetadata.resultMetaData.timeTaken,
            links: response.searchResultMetadata.resultMetaData._links,
        };

        const claimsData = [];
        const getValueOrDefault = (value, defaultValue = "—") =>
            typeof value === "number" || !!(value && value.trim())
                ? value
                : defaultValue;
        // getAddressData and postalAddresses removed
        if (response.claims && Array.isArray(response.claims)) {
            response.claims.forEach((claim) => {
                if (
                    hasInErrorReason(
                        claim.claimProcessingStage,
                        claim.customClaimStatusReason,
                        claim.claimStatusReason,
                        claim.claimStatusReasonDesc,
                        claim.claimStatusReasonCdDesc,
                        claim.customClaimStatusReasonCdDesc
                    )
                )
                    return;

                const claimantDetails = claim.claimantDetails || {};
                const coverageDetails = claim.coverageDetails || {};
                const disabilityDetails = claim.disabilityDetails || {};
                const employeeInformation = claim.employeeInformation || {};
                // addressData removed
                const claimData = {
                    // paymentDetails and recentPaymentDetails fields removed
                    monthlyCoveredSalaryAmt: getValueOrDefault(
                        coverageDetails.monthlyCoveredSalaryAmt
                    ),
                    claimId: getValueOrDefault(claim.claimId),
                    legacyClaimNumber: getValueOrDefault(claim.aliasClaimId),
                    claimSystemCd: getValueOrDefault(claim.claimSystemCd),
                    // paymentDetails fields removed
                    claimStatus: getValueOrDefault(claim.derivedClaimStatusDesc),
                    claimStatusReason: getValueOrDefault(
                        claim.customClaimStatusReason
                    ),
                    statusEffectiveDt: getValueOrDefault(
                        claim.claimStatusEffectiveDt
                    ),
                    claimApprovedThruDt: getValueOrDefault(
                        claim.claimApprovedThruDt
                    ),
                    claimBenefitBeginDt: getValueOrDefault(
                        claim.claimBenefitBeginDt
                    ),
                    claimBenefitEndDt: getValueOrDefault(
                        claim.claimBenefitEndDt
                    ),
                    benefitResumeDt: getValueOrDefault(claim.benefitResumeDate),
                    claimPaidThroughDate: getValueOrDefault(
                        claim.claimPaidThroughDate
                    ),
                    // paymentDetails fields removed
                    claimClosedDt: getValueOrDefault(claim.claimClosedDt),
                    eliminationPeriodEndDate: getValueOrDefault(
                        claim.eliminationPeriodEndDate
                    ),
                    // paymentDetails fields removed
                    claimMaxDurationDt: getValueOrDefault(
                        claim.claimMaxDurationDt
                    ),
                    receivedDt: getValueOrDefault(claim.claimReceivedTs),
                    fullName: getValueOrDefault(
                        claimantDetails.claimantDisplayName
                    ),
                    firstName: getValueOrDefault(claimantDetails.firstName),
                    lastName: getValueOrDefault(claimantDetails.lastName),
                    dateOfBirth: getValueOrDefault(claimantDetails.dateOfBirth),
                    genderAtBirth: getValueOrDefault(
                        claimantDetails.genderAtBirth
                    ),
                    postalCode: getValueOrDefault(claimantDetails.postalCode),
                    hireDt: getValueOrDefault(claimantDetails.hireDt),
                    jobTitle: getValueOrDefault(claimantDetails.jobTitleName),
                    personDisplayName: getValueOrDefault(
                        claim.claimOwner?.personDisplayName
                    ),
                    personID: getValueOrDefault(claim.claimOwner?.personID),
                    // digitalAddresses removed
                    taxIdentificationNumber: getValueOrDefault(
                        claimantDetails.taxIdentificationNumber
                    ),
                    divisionId: getValueOrDefault(coverageDetails.divisionId),
                    coverageSourceDesc: getValueOrDefault(
                        coverageDetails.customCoverageDesc
                    ),
                    divisionName: getValueOrDefault(
                        coverageDetails.divisionName
                    ),
                    weeklyCoveredSalaryAmt: getValueOrDefault(
                        coverageDetails.weeklyCoveredSalaryAmt
                    ),
                    ReportingLocation: getValueOrDefault(
                        employeeInformation.employeeLocationName
                    ),
                    eligibilityGroup: getValueOrDefault(
                        coverageDetails.eligibilityGroup
                    ),
                    eligibilityGroupDesc: getValueOrDefault(
                        coverageDetails.eligibilityGroupDesc
                    ),
                    groupAgreementId: getValueOrDefault(
                        coverageDetails.groupAgreementID
                    ),
                    choiceCd: getValueOrDefault(coverageDetails.choiceCd),
                    empContributionPremiumAmt: getValueOrDefault(
                        coverageDetails.empContributionPremiumAmt
                    ),
                    coverageType: getValueOrDefault(claim.claimCoverageTypeCd),
                    disabilityBeginDt:RemoveYear(getValueOrDefault(
                                  disabilityDetails.disabilityBeginDt
                              )),
                       
                    lagDays: getValueOrDefault(disabilityDetails.lagDays),
                    primaryDiagnosisCd: getValueOrDefault(
                        disabilityDetails.primaryDiagnosisCd
                    ),
                    primaryDiagnosisDesc: getValueOrDefault(
                        disabilityDetails.primaryDiagnosisDesc
                    ),
                    secondaryDiagnosisCd: getValueOrDefault(
                        disabilityDetails.secondaryDiagnosisCd
                    ),
                    secondaryDiagnosisDesc: getValueOrDefault(
                        disabilityDetails.secondaryDiagnosisDesc
                    ),
                    workLevel: getValueOrDefault(disabilityDetails.workLevel),
                    workRelatedInd: getValueOrDefault(
                        disabilityDetails.workRelatedInd
                    ),
                    actualDeliveryDt:RemoveYear(getValueOrDefault(
                                  disabilityDetails.actualDeliveryDt
                              )),
                        
                    lastDateWorked: getValueOrDefault(
                        disabilityDetails.lastWorkedDt
                    ),
                    partTimeRTWDt:RemoveYear(getValueOrDefault(
                                  disabilityDetails.partTimeRtwDt
                              )),
                       
                    fullTimeRTWDt:RemoveYear(getValueOrDefault(
                                  disabilityDetails.fullTimeRtwDt
                              )),
                        
                    takeoverClaimInd: getValueOrDefault(claim.takeoverClaimInd),
                    claimDecisionDt: getValueOrDefault(claim.claimDecisionDt),
                    employeeContributionPostTaxPct: getValueOrDefault(
                        claim.employeeContributionPostTaxPct
                    ),
                    age: getValueOrDefault(claimantDetails.age),
                    duration: getValueOrDefault(claim.duration),
                };
                claimsData.push(claimData);
            });
        }
        return { claimsData, searchResultMetadata };
    };
}

export default new DisabilitySnapshotsData();
